import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import _ from "lodash";
import { PENDENCIA_ASSINATURA_LOAD, PENDENCIA_ASSINATURA_UNLOAD } from "../../actions/Constants";
import api from "../../api/apiUtil";
import Title from "../../components/Layout/Title";
import MaskDate from "../../components/Util/MaskDate";
import fileDownload from "js-file-download";
import { Link } from "react-router";

class PendenciaAssinatura extends React.Component {
  componentDidMount() {
    this.props.onLoad(Promise.resolve(api.Contracts.getPendenciaAssinatura()));
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  handleClickDownload = (param) => {
    Promise.resolve(api.Contracts.getImage(param.idContrato))
      .then((response) => {
        fileDownload(response, param.nome);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  render() {
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Os arquivos que não foram assinados digitalmente, serão exibidos abaixo" />{" "}
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-body">
                  <div className="table-responsive">
                    {this.props.all && this.props.all.length > 0 ? (
                      <table cellPadding="1" cellSpacing="1" className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th className="text-center align-middle">Número do Contrato</th>
                            <th className="text-center align-middle">Nome do Arquivo</th>
                            <th className="text-center align-middle">Data Inclusão do Arquivo</th>
                            <th className="text-center align-middle" style={{ width: "5%" }}>
                              Ações
                            </th>
                          </tr>
                        </thead>
                        <tbody>{this.renderList()}</tbody>
                      </table>
                    ) : (
                      <small>Nenhum registro encontrado</small>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderList() {
    if (!this.props.all) {
      return null;
    }
    return this.props.all.map((pendencia, index) => {
      return (
        <tr key={index}>
          <td className="text-center align-middle">{pendencia.numero}</td>
          <td className="text-center align-middle">{pendencia.nome}</td>
          <td className="text-center align-middle">{MaskDate.TO_BR_DATE(pendencia.data)}</td>
          <td className="align-middle text-center">
            <div className="btn-group">
              <>
                <Link className="btn btn-default btn-sm" onClick={() => this.handleClickDownload(pendencia)}>
                  <i className="fa fa-download" title="Baixar imagem"></i>
                </Link>
              </>
            </div>
          </td>
        </tr>
      );
    });
  }
}

const mapDispatchToProps = (dispatch) => ({
  onLoad: (payload) => dispatch({ type: PENDENCIA_ASSINATURA_LOAD, payload }),
  onUnload: (payload) => dispatch({ type: PENDENCIA_ASSINATURA_UNLOAD, payload }),
});

const mapStateToProps = (state) => ({
  ...state.pendenciaAssinatura,
});

const form = reduxForm({
  form: "PendenciaAssinaturaForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(PendenciaAssinatura));
